import { useMemo } from "react";
import { object, string, date } from "yup";
import { testBirthdate, testTelephone, testTitre } from "src/commun/utils/ValidationsUtils";
import { Title } from "src/commun/hooks/useTitreOptions";

export type InfoPersoUpdate = {
  title: Title;
  firstName: string;
  lastName: string;
  birthdate: string;
  telephonePro: string;
};

const useValidationSchemaInfoPersoUpdate = () => {
  return useMemo(() => {
    const requiredMessage = "form.error.notEmpty";
    const invalidMessage = "form.error.invalid";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<InfoPersoUpdate>().shape({
      title: string().required(requiredMessage).test("test-title", invalidMessage, value => testTitre(value)),
      lastName: string().required(requiredMessage),
      firstName: string().required(requiredMessage),
      birthdate: date().required(requiredMessage).typeError("").test("test-birthdate", "", value => testBirthdate(value)),
      telephonePro: string().nullable().test("telephone-format-fr-ch", invalidMessage, (value) => testTelephone(value)),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaInfoPersoUpdate;
